import { createRoot } from 'react-dom/client';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

// google-fonts
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project import
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import { PageSizeProvider } from 'contexts/PageSizeContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Handle React chunk loading failures (dynamic imports)
// This prevents blank screens when new builds are deployed and browser cache is stale
// The browser is loading an OLD main bundle which points to NEW chunk URLs

// Simple flag to prevent infinite reload loops
let isReloading = false;

// Check if error is a chunk loading error
const isChunkLoadingError = (error) => {
  if (!error) return false;

  const errorMessage = error.message || error.toString() || '';
  const errorTarget = error.target || {};
  const errorSrc = errorTarget.src || errorTarget.href || '';

  // Check error message for chunk-related patterns
  const chunkErrorPatterns = [
    'Loading chunk',
    'loading chunk',
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    'ChunkLoadError',
    'chunk load',
    'Failed to load chunk',
    'Loading CSS chunk'
  ];

  const hasChunkErrorPattern = chunkErrorPatterns.some(pattern => 
    errorMessage.toLowerCase().includes(pattern.toLowerCase())
  );

  // Check if it's a script/style loading error on chunk files
  const isChunkFileError = (
    (errorTarget.tagName === 'SCRIPT' || errorTarget.tagName === 'LINK') &&
    errorSrc &&
    (errorSrc.includes('static/js/') || 
     errorSrc.includes('static/css/') || 
     errorSrc.includes('chunk'))
  );

  return hasChunkErrorPattern || isChunkFileError;
};

// Handle error events (script/style loading errors)
window.addEventListener("error", (e) => {
  if (!isReloading && isChunkLoadingError(e)) {
    console.warn("Chunk load failed, reloading...", e.message || e.target?.src);
    isReloading = true;
    window.location.reload();
  }
}, true); // Use capture phase to catch errors earlier

// Handle unhandled promise rejections (Vite/CRA bug)
window.addEventListener("unhandledrejection", (e) => {
  if (!isReloading && isChunkLoadingError(e.reason)) {
    console.warn("Chunk load failed (promise), reloading...", e.reason?.message || e.reason);
    e.preventDefault();
    isReloading = true;
    window.location.reload();
  }
});

// Reset reload flag on successful page load
window.addEventListener("load", () => {
  isReloading = false;
});

const container = document.getElementById('root');
const root = createRoot(container);
serviceWorkerRegistration.register();

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <PageSizeProvider>
      <App />
    </PageSizeProvider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();